module.exports = __webpack_public_path__ + "img/Smeeb.90b26248.jpg";